import { Component, Inject, OnInit, Optional } from '@angular/core';
import { UserService } from '@ml/core/services';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { User } from '@ml/core/types/classes';

@Component({
  selector: 'ml-change-password',
  template: `
    <div class="full-height full-width" fxLayout="row">
      <mat-card class="change-password__card">
        <ml-change-password-form (changePassword)="onChangePassword($event)">
        </ml-change-password-form>
      </mat-card>
    </div>
  `,
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  public data?: { userId?: number };
  constructor(
    private userService: UserService,
    private router: Router,
    @Optional() private dialogRef?: MatDialogRef<ChangePasswordComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) dialogData?: { userId?: number }
  ) {
    this.data = dialogData;
  }

  ngOnInit() { }

  onChangePassword(password: string) {
    const afterChange = () => {
      // If dialogRef exists and is open, just close the dialog
      if (this.dialogRef) {
        this.dialogRef.close();
      } else {
        this.router.navigate(['/']);
      }
    };
    if (this.data == null || this.data.userId == null) {
      this.userService.changeOwnPassword(password).subscribe(afterChange);
    } else {
      this.userService
        .changeOthersPassword(this.data.userId, password)
        .subscribe(afterChange);
    }
  }
}
